<template>
  <div class="popup-back" :style="`display: ${visibleState}`">
    <div class="popup all-category-list-layer">
      <div class="popup-button-close">
        <button @click.prevent="closeLayer">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAP9JREFUSA3tlUsKwjAQhou3cyWuu2t3vYDgAXovPUi7EbyDCvULdEoZzYsmG83AT/qYf75kQkhVlSgd+JsOTNN0QFdUxy4azx5dUBvrrTAZqEQXWgDDET1m4xjqW/Iw1rNZBi+cxDXU+E5LwZgHjJ1xr8IKJ0dD+xjWRy4FvfDkUJmFC54N6oJnhzrgT+AS2/ZUILYRit5zA46G7mwAx/c7/17q/029p31lZfrImNVKWI/apllQXUN7vum2p4V/g8oqssFd0GzwEGhyOFBztcktw6P/yJCj97yRiQWPFDH3qUTwOcWwhg/BQEmkQItGFH214WnQgM5Sr4ylA7/fgTe/2zTk30iqjgAAAABJRU5ErkJggg=="
            alt="btn-close">
        </button>
      </div>
      <div class="all-category-list-wrap">
        <h2>전체 카테고리</h2>
        <div>
          <ul :class="getListWrapperClass">
            <template v-for="(sectionInfo, index) in multiSectionList">
              <DynamicSectionLoader :section-info="sectionInfo" :key="sectionInfo.title + index"/>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CATEGORY_BAND_NUMBER_KEY,
  CATEGORY_CTYPE_MENU, CATEGORY_CTYPE_MY,
  categoryInfo,
  EVENT_CLOSE_CATEGORY_LAYOUT,
  EVENT_OPEN_CATEGORY_LAYOUT,
  setCategoryMenu
} from '@/common/utils/gnb.category'
import DynamicSectionLoader from '@/components/container/DynamicSectionLoader'
import _ from 'lodash'
import fp from 'lodash/fp'
import { parseUrl } from 'query-string'
import { getSectionEventByType } from '@/common/utils/gnb.fp'
import { EVENT_TYPE } from '@/common/resources/const'

export default {
  name: 'CategoryMenuLayer',
  components: { DynamicSectionLoader },
  props: {},
  data () {
    return {
      isOpen: false,
      multiSectionList: [],
      recommendCategoryList: []
    }
  },
  methods: {
    openLayer () {
      this.isOpen = true
      this.$nextTick(() => {
        this.toggleTabIndexToRecommendCategory(true)
      })
    },
    closeLayer () {
      this.isOpen = false
      this.$nextTick(() => {
        this.toggleTabIndexToRecommendCategory(false)
      })
    },
    getRecommendCategoryList () {
      if (this.recommendCategoryList.length === 0) {
        this.recommendCategoryList = document.querySelectorAll('[data-recommend-category="true"] > a')
      }
      return this.recommendCategoryList
    },
    toggleTabIndexToRecommendCategory (addIndex) {
      const recommendCategoryList = this.getRecommendCategoryList()
      for (let i = 0; i < recommendCategoryList.length; i++) {
        recommendCategoryList[i].setAttribute('tabindex', addIndex ? '1' : '0')
      }
    },
    attachLayoutEvent () {
      this.$events.$on(EVENT_OPEN_CATEGORY_LAYOUT, this.openLayer)
      this.$events.$on(EVENT_CLOSE_CATEGORY_LAYOUT, this.closeLayer)
    },
    detachLayoutEvent () {
      this.$events.$off(EVENT_OPEN_CATEGORY_LAYOUT, this.openLayer)
      this.$events.$off(EVENT_CLOSE_CATEGORY_LAYOUT, this.closeLayer)
    },
    fetchMenuList () {
      const fetchFn = categoryInfo.hasMultiSectionResponse()
        ? () => new Promise((resolve) => {
          resolve(true)
        }) : setCategoryMenu
      fetchFn().then(() => {
        const filteredMultiSectionList =
          _.get(categoryInfo, 'multiSectionResponse.data.multisectionlist', [])
          .filter((multiSection) => {
            const onContent = getSectionEventByType(EVENT_TYPE.ON_CONTENT)(multiSection)
            const url = _.get(onContent, 'url', '')
            const { query } = parseUrl(url)
            const cType = _.get(query, 'ctype', '')
            const bandNumber = _.get(multiSection, 'cell_type', '')
            return cType !== CATEGORY_CTYPE_MENU &&
              cType !== CATEGORY_CTYPE_MY &&
              bandNumber === CATEGORY_BAND_NUMBER_KEY
          })
        .map((filteredMultiSection) => {
          return fp.set('cell_type', 'band_category_layer')(filteredMultiSection)
        })
        this.multiSectionList = filteredMultiSectionList.splice(0, 5)
      })
    }
  },
  computed: {
    visibleState () {
      return this.isOpen ? 'block' : 'none'
    },
    getListWrapperClass () {
      return `all-category-list column-${this.multiSectionList.length}`
    }
  },
  created () {
    this.attachLayoutEvent()
    this.fetchMenuList()
  },
  beforeDestroy () {
    this.detachLayoutEvent()
  }
}
</script>
